import * as React from 'react';
import { ScrollView } from '@progress/kendo-react-scrollview';

interface ImagesGalleryProps {
    ImagesUrls: string[];
  }

  const ImagesGalleryComponent: React.FC<ImagesGalleryProps> = ({ ImagesUrls }) => {
    if (!ImagesUrls || ImagesUrls.length === 0) {
      return null;
    }
  
    return (
        <div style={{ maxHeight: '400px', overflow: 'hidden' }}>
          <ScrollView
            style={{ width: '100%', height: '400px' }}
            arrows={true}
            automaticViewChange={false}
          >
            {ImagesUrls.map((url, index) => (
              <div
                key={index}
                style={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    width: '100%',
                    textDecoration: 'none',
                  }}
                >
                  <img
                    src={url}
                    alt={`Slide ${index}`}
                    style={{ maxHeight: '100%', maxWidth: '100%' }}
                    draggable={false}
                  />
                </a>
              </div>
            ))}
          </ScrollView>
        </div>
      );
    };
  
  export default ImagesGalleryComponent;